import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ErrorPageContent = ({ title, description }) => {
    return (_jsxs("div", { className: "error-page-content section-container", children: [title && _jsx("h2", { className: "error-page-content-title", children: title }), _jsx("div", { className: "error-page-content-description", dangerouslySetInnerHTML: { __html: description } })] }));
};
export default ErrorPageContent;
